<app-nav></app-nav>

<section [ngClass]="{'gradient-2': !global.color_filter, 'bg-gray': global.color_filter}">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 text-center">
        <img class="icon-cover-page" src="assets/img/icons/icon-citas.png">
        <h1
          [ngClass]="{'bigger-t mt-2 mb-5': true, 'white': !global.color_filter, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
          SOLICITE SU CITA MÉDICA</h1>
      </div>
    </div>
  </div>
</section>

<section class="mt-5" id="sede-anchor">
  <div class="container">
    <div class="row">
      <div class="col-12">

        <h5 class="roboto fs-5 mb-3" *ngIf="userMail">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor"
            class="bi bi-person-circle mb-1 me-1" style="color: #6610f2;" viewBox="0 0 16 16">
            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
            <path fill-rule="evenodd"
              d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z" />
          </svg>
          Hola, {{userMail}}
        </h5>

        <mat-stepper #stepper class="mb-5 bg-gray corners-rounded" style="padding: 0px 0px 0px 0px;"
          [orientation]="stepperOrientation | async">

          <mat-step [completed]="!!selectedServicio">
            <ng-template matStepLabel>Servicio</ng-template>

            <div class="container-fluid g-0 g-md-4">


              <div *ngIf="errorStep1" class="alert alert-warning" role="alert">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-exclamation-triangle-fill" style="color: red;" viewBox="0 0 16 16">
                  <path
                    d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                </svg>
                Error: {{errorStep1}}
              </div>

              <div *ngIf="!errorStep1 && btnStart" class="row">
                <div class="col-12">
                  <div class="py-5">
                    <div class="d-flex justify-content-center">
                      <span
                        [ngClass]="{'big-t title-line-height mt-3 mb-3': true, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                        SOLICITE SU CITA
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                          class="bi bi-hand-index-thumb" viewBox="0 0 16 16">
                          <path
                            d="M6.75 1a.75.75 0 0 1 .75.75V8a.5.5 0 0 0 1 0V5.467l.086-.004c.317-.012.637-.008.816.027.134.027.294.096.448.182.077.042.15.147.15.314V8a.5.5 0 0 0 1 0V6.435l.106-.01c.316-.024.584-.01.708.04.118.046.3.207.486.43.081.096.15.19.2.259V8.5a.5.5 0 1 0 1 0v-1h.342a1 1 0 0 1 .995 1.1l-.271 2.715a2.5 2.5 0 0 1-.317.991l-1.395 2.442a.5.5 0 0 1-.434.252H6.118a.5.5 0 0 1-.447-.276l-1.232-2.465-2.512-4.185a.517.517 0 0 1 .809-.631l2.41 2.41A.5.5 0 0 0 6 9.5V1.75A.75.75 0 0 1 6.75 1zM8.5 4.466V1.75a1.75 1.75 0 1 0-3.5 0v6.543L3.443 6.736A1.517 1.517 0 0 0 1.07 8.588l2.491 4.153 1.215 2.43A1.5 1.5 0 0 0 6.118 16h6.302a1.5 1.5 0 0 0 1.302-.756l1.395-2.441a3.5 3.5 0 0 0 .444-1.389l.271-2.715a2 2 0 0 0-1.99-2.199h-.581a5.114 5.114 0 0 0-.195-.248c-.191-.229-.51-.568-.88-.716-.364-.146-.846-.132-1.158-.108l-.132.012a1.26 1.26 0 0 0-.56-.642 2.632 2.632 0 0 0-.738-.288c-.31-.062-.739-.058-1.05-.046l-.048.002z" />
                        </svg>
                      </span>
                    </div>
                    <div class="d-flex justify-content-center">
                      <button *ngIf="btnClick" type="button"
                        [ngClass]="{'btn mb-5 btn-lg': true,'cursor': global.cursor_btn, 'btn-warning': !global.color_filter, 'btn-dark': global.color_filter}"
                        (click)="listarServicios()">
                        EMPEZAR PROCESO
                      </button>
                      <button class="btn btn-warning btn-lg" type="button" disabled *ngIf="btnSpinner && !errorStep1">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        CARGANDO INFORMACIÓN...
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="!btnStart && !especialidadSeleccionada" class="row g-0 g-md-4 d-flex justify-content-center">

                <div class="col-12">

                  <div class="d-flex justify-content-center align-items-center w-100 py-5 none-phone">
                    <div class="icon-head">
                      <img class="img-fluid w-100" src="assets/img/citas/herocita.svg" alt="Icon decorartivo">
                    </div>
                    <div class="ps-4">
                      <span
                        [ngClass]="{'big-t title-line-height': true, 'blue': !global.color_filter, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                        BUSCAR SERVICIO
                      </span>
                      <p
                        [ngClass]="{'':true, 'medium-f': !global.dislex, 'dislex': global.dislex, 'sizetext': global.sizetext}">
                        Escriba el nombre del servicio que busca</p>
                      <div class="input-group mt-3 mb-4">
                        <input type="text" class="form-control" placeholder="Buscar un servicio"
                          aria-label="Buscar un servicio" [ngModel]="terminoBusqueda"
                          (ngModelChange)="onBuscarServicios($event)"
                          (keyup.enter)="onBuscarServicios(terminoBusqueda)" />

                        <!-- Botón con ícono de lupa -->
                        <button class="btn btn-primary" type="button" id="button-addon-buscar" aria-label="Buscar"
                          (click)="onBuscarServicios(terminoBusqueda)">
                          <!-- Ícono lupa (SVG inline, no requiere bootstrap-icons) -->
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-search" viewBox="0 0 16 16">
                            <path
                              d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                          </svg>
                        </button>

                        <!-- (Opcional) botón para limpiar cuando hay texto -->
                        <button class="btn btn-dark" type="button" aria-label="Limpiar búsqueda" *ngIf="terminoBusqueda"
                          (click)="limpiarBusqueda()">
                          <!-- X (SVG inline) -->
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                            <path fill-rule="evenodd"
                              d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" />
                            <path
                              d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                          </svg>
                        </button>
                      </div>

                    </div>
                  </div>

                  <div class="row only-phone">
                    <div class="col-12">
                      <div class="w-100 d-flex justify-content-center">
                        <div class="icon-head">
                          <img class="img-fluid w-100" src="assets/img/citas/herocita.svg" alt="Icon decorartivo">
                        </div>
                      </div>

                    </div>
                    <div class="col-12">
                      <div class="text-center">
                        <span
                          [ngClass]="{'big-t title-line-height': true, 'blue': !global.color_filter, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                          BUSCAR SERVICIO
                        </span>
                        <p
                          [ngClass]="{'':true, 'medium-f': !global.dislex, 'dislex': global.dislex, 'sizetext': global.sizetext}">
                          Escriba el nombre del servicio que busca</p>
                        <div class="input-group mt-3 mb-4">
                          <input type="text" class="form-control" placeholder="Buscar un servicio"
                            aria-label="Buscar un servicio" [ngModel]="terminoBusqueda"
                            (ngModelChange)="onBuscarServicios($event)"
                            (keyup.enter)="onBuscarServicios(terminoBusqueda)" />

                          <!-- Botón con ícono de lupa -->
                          <button class="btn btn-primary" type="button" id="button-addon-buscar" aria-label="Buscar"
                            (click)="onBuscarServicios(terminoBusqueda)">
                            <!-- Ícono lupa (SVG inline, no requiere bootstrap-icons) -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                              class="bi bi-search" viewBox="0 0 16 16">
                              <path
                                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                            </svg>
                          </button>

                          <!-- (Opcional) botón para limpiar cuando hay texto -->
                          <button class="btn btn-dark" type="button" aria-label="Limpiar búsqueda"
                            *ngIf="terminoBusqueda" (click)="limpiarBusqueda()">
                            <!-- X (SVG inline) -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                              class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                              <path fill-rule="evenodd"
                                d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" />
                              <path
                                d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                            </svg>
                          </button>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="row" *ngIf="!buscandoServicios && !especialidadSeleccionada">
                    <div class="w-100 text-center pt-4">
                      <span
                        [ngClass]="{'big-t title-line-height': true, 'blue': !global.color_filter, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                        Busca por especialidad
                      </span>
                    </div>
                    <div class="col-12 col-md-6 col-xl-4 py-2" *ngFor="let especialidad of especialidades | keyvalue">
                      <a (click)="seleccionarEspecialidad(especialidad.key); scrollToTop200('#sede-anchor')">
                        <div class="box-hover py-3 px-2 d-flex flex-sm-column flex-row align-items-center">
                          <div class="icon-mobile-esp me-2 me-md-0">
                            <img class="w-100" src="assets/img/citas/icon-esp.svg" alt="Icon decorativo">
                          </div>
                          <div class="text-center text-sm-start">
                            <span
                              [ngClass]="{'big-t title-line-height text-center': true, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                              {{ especialidad.key }}
                            </span>
                          </div>
                        </div>
                      </a>
                    </div>

                  </div>

                  <div class="row" *ngIf="buscandoServicios">
                    <div class="alert alert-warning" role="alert" *ngIf="resultadosBusqueda.length === 0">
                      No encontramos servicios que coincidan con "{{terminoBusqueda}}". Intente con otro término o
                      revise la ortografía.
                    </div>

                    <div class="row g-3 mt-2" *ngIf="resultadosBusqueda.length > 0">
                      <div class="col-12 col-md-6 col-lg-4" *ngFor="let servicio of resultadosBusqueda">
                        <div class="card seleccion-card h-100 cursor-pointer"
                          [ngClass]="{'seleccion-card-active': selectedServicio?.key === servicio.key}"
                          (click)="seleccionarServicio(servicio, stepper); scrollToTop200('#sede-anchor')">

                          <div class="card-body d-flex flex-column">
                            <span class="text-big bold-f">{{servicio.value.especialidad}}</span>
                            <div>
                              <span class="text-normal mb-2">{{servicio.value.nombre}}</span>
                              <p class="text-muted small mb-0" *ngIf="servicio.value.observaciones">
                                <span class="bold-f">Observaciones:</span> {{servicio.value.observaciones |
                                slice:0:120}}{{servicio.value.observaciones.length >
                                120
                                ? '...' : ''}}
                              </p>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="!buscandoServicios && especialidadSeleccionada" class="row">
                <div class="col-12">
                  <div class="">
                    <button type="button" class="btn btn-secondary btn-sm" (click)="volverEspecialidades()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-arrow-left mb-1" viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                          d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                      </svg> Ir Atrás
                    </button>
                  </div>
                </div>
                <div class="col-12">
                  <div class="py-5">
                    <div class=" d-flex justify-content-center">
                      <div class="icon-head">
                        <img class="img-fluid w-100" src="assets/img/citas/herocita.svg" alt="Icon decorartivo">
                      </div>
                    </div>
                    <div class="pt-2 d-flex justify-content-center text-center">
                      <span
                        [ngClass]="{'big-t title-line-height': true, 'blue': !global.color_filter, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                        SERVICIOS DE {{especialidadSeleccionada}}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="alert alert-warning mt-3 w-100" role="alert"
                    *ngIf="obtenerServiciosDeEspecialidad().length === 0">
                    No hay servicios disponibles para esta especialidad en este momento.
                  </div>
                </div>

                <div class="col-12 col-md-6 col-xl-4 pb-3" *ngFor="let servicio of obtenerServiciosDeEspecialidad()">
                  <div class="box-hover pt-2 pb-1 px-2 d-flex justify-content-between align-items-center"
                    (click)="seleccionarServicio(servicio, stepper); scrollToTop200('#sede-anchor')">
                    <div class="d-flex">
                      <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
                          class="bi bi-dot yellow mb-1" viewBox="0 0 16 16">
                          <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
                        </svg>
                      </div>
                      <span
                        [ngClass]="{'text-normal': true, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                        {{servicio.value.nombre}}</span>
                    </div>

                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
                        class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                      </svg>
                    </span>
                  </div>
                </div>


              </div>

              <div class="row MARIODIV">
                <!--  <div class="col-12 g-0 g-md-4 text-center">
                  <h3 *ngIf="btnStart"
                    [ngClass]="{'big-t title-line-height mt-3 mb-3': true, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                    CLICK PARA SOLICITAR SU CITA
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
                      class="bi bi-hand-index-thumb" viewBox="0 0 16 16">
                      <path
                        d="M6.75 1a.75.75 0 0 1 .75.75V8a.5.5 0 0 0 1 0V5.467l.086-.004c.317-.012.637-.008.816.027.134.027.294.096.448.182.077.042.15.147.15.314V8a.5.5 0 0 0 1 0V6.435l.106-.01c.316-.024.584-.01.708.04.118.046.3.207.486.43.081.096.15.19.2.259V8.5a.5.5 0 1 0 1 0v-1h.342a1 1 0 0 1 .995 1.1l-.271 2.715a2.5 2.5 0 0 1-.317.991l-1.395 2.442a.5.5 0 0 1-.434.252H6.118a.5.5 0 0 1-.447-.276l-1.232-2.465-2.512-4.185a.517.517 0 0 1 .809-.631l2.41 2.41A.5.5 0 0 0 6 9.5V1.75A.75.75 0 0 1 6.75 1zM8.5 4.466V1.75a1.75 1.75 0 1 0-3.5 0v6.543L3.443 6.736A1.517 1.517 0 0 0 1.07 8.588l2.491 4.153 1.215 2.43A1.5 1.5 0 0 0 6.118 16h6.302a1.5 1.5 0 0 0 1.302-.756l1.395-2.441a3.5 3.5 0 0 0 .444-1.389l.271-2.715a2 2 0 0 0-1.99-2.199h-.581a5.114 5.114 0 0 0-.195-.248c-.191-.229-.51-.568-.88-.716-.364-.146-.846-.132-1.158-.108l-.132.012a1.26 1.26 0 0 0-.56-.642 2.632 2.632 0 0 0-.738-.288c-.31-.062-.739-.058-1.05-.046l-.048.002z" />
                    </svg>
                  </h3>
                  <button *ngIf="btnClick" type="button"
                    [ngClass]="{'btn mb-5 btn-lg': true,'cursor': global.cursor_btn, 'btn-warning': !global.color_filter, 'btn-dark': global.color_filter}"
                    (click)="listarServicios()">
                    SOLICITAR UNA CITA
                  </button>
                  <button class="btn btn-warning btn-lg" type="button" disabled *ngIf="btnSpinner && !errorStep1">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    CARGANDO INFORMACIÓN...
                  </button>
                  <p *ngIf="errorStep1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-exclamation-triangle-fill" style="color: red;" viewBox="0 0 16 16">
                      <path
                        d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                    </svg>
                    Error: {{errorStep1}}
                  </p>
                  <h3 *ngIf="!btnStart"
                    [ngClass]="{'big-t title-line-height mt-3 mb-3': true, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                    {{especialidadSeleccionada ? ('SERVICIOS DE ' + especialidadSeleccionada) : 'BUSCAR POR
                    ESPECIALIDAD'}}
                  </h3>
                </div> -->

                <!--    <div class="col-12 col-lg-8 col-xl-6 mx-auto" *ngIf="!btnStart">
                  <div class="input-group buscador-servicios mt-3 mb-4">
                    <span class="input-group-text">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                        class="bi bi-search" viewBox="0 0 16 16">
                        <path
                          d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12.5 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                      </svg>
                    </span>
                    <input type="text" class="form-control" placeholder="Buscar un servicio" [value]="terminoBusqueda"
                      (input)="onBuscarServicios($event.target.value)">
                    <button class="btn btn-outline-secondary" type="button" *ngIf="terminoBusqueda"
                      (click)="limpiarBusqueda()">
                      Limpiar
                    </button>
                  </div>
                </div> -->

                <!--     <div class="col-12" *ngIf="!btnStart">
                  <div *ngIf="buscandoServicios">
                    <div class="alert alert-warning" role="alert" *ngIf="resultadosBusqueda.length === 0">
                      No encontramos servicios que coincidan con "{{terminoBusqueda}}". Intente con otro término o
                      revise la ortografía.
                    </div>
                    <div class="row g-3 mt-2" *ngIf="resultadosBusqueda.length > 0">
                      <div class="col-12 col-md-6 col-lg-4" *ngFor="let servicio of resultadosBusqueda">
                        <div class="card seleccion-card h-100 cursor-pointer"
                          [ngClass]="{'seleccion-card-active': selectedServicio?.key === servicio.key}"
                          (click)="seleccionarServicio(servicio, stepper)">
                          <div class="card-body d-flex flex-column">
                            <span class="badge bg-light text-dark mb-2">{{servicio.value.especialidad}}</span>
                            <h5 class="card-title mb-2">{{servicio.value.nombre}}</h5>
                            <p class="text-muted small mb-2" *ngIf="servicio.value.servicio_api_sinonimos">
                              <strong>Sinónimos:</strong> {{servicio.value.servicio_api_sinonimos}}
                            </p>
                            <p class="text-muted small mb-0" *ngIf="servicio.value.observaciones">
                              {{servicio.value.observaciones | slice:0:120}}{{servicio.value.observaciones.length > 120
                              ? '...' : ''}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="!buscandoServicios && !especialidadSeleccionada">
                    <div class="alert alert-warning mt-4" role="alert" *ngIf="(especialidades | keyvalue).length === 0">
                      No hay especialidades disponibles en este momento. Intente nuevamente mas tarde.
                    </div>

                    <div class="row g-3 mt-2" *ngIf="(especialidades | keyvalue).length > 0">
                      <div class="col-12 col-md-6 col-lg-4" *ngFor="let especialidad of especialidades | keyvalue">
                        <div class="card seleccion-card h-100 cursor-pointer"
                          (click)="seleccionarEspecialidad(especialidad.key)">
                          <div class="card-body d-flex flex-column">
                            <h5 class="card-title mb-2">{{especialidad.key}}</h5>
                            <p class="text-muted mb-0">
                              Servicios disponibles: {{especialidad.value.length}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="!buscandoServicios && especialidadSeleccionada">
                    <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between mt-3">
                      <p class="mb-2 mb-md-0 text-muted">Especialidad seleccionada:
                        <strong>{{especialidadSeleccionada}}</strong>
                      </p>
                      <button type="button" class="btn btn-link px-0" (click)="volverEspecialidades()">
                        Cambiar especialidad
                      </button>
                    </div>

                    <div class="alert alert-warning mt-3" role="alert"
                      *ngIf="obtenerServiciosDeEspecialidad().length === 0">
                      No hay servicios disponibles para esta especialidad en este momento.
                    </div>

                    <div class="row g-3 mt-2" *ngIf="obtenerServiciosDeEspecialidad().length > 0">
                      <div class="col-12 col-md-6 col-lg-4" *ngFor="let servicio of obtenerServiciosDeEspecialidad()">
                        <div class="card seleccion-card h-100 cursor-pointer"
                          [ngClass]="{'seleccion-card-active': selectedServicio?.key === servicio.key}"
                          (click)="seleccionarServicio(servicio, stepper)">
                          <div class="card-body d-flex flex-column">
                            <h5 class="card-title mb-2">{{servicio.value.nombre}}</h5>
                            <p class="text-muted small mb-2" *ngIf="servicio.value.observaciones">
                              {{servicio.value.observaciones | slice:0:120}}{{servicio.value.observaciones.length > 120
                              ? '...' : ''}}
                            </p>
                            <p class="text-muted small mb-0" *ngIf="!servicio.value.observaciones">
                              Sin observaciones.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->

              </div>

            </div>

            <div class="text-center">
              <p class="text-muted text-small mt-5">This site is protected by reCAPTCHA Enterprise and the Google
                <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                <a href="https://policies.google.com/terms">Terms of Service</a> apply.
              </p>
            </div>
          </mat-step>

          <mat-step [completed]="!!sucursalSeleccionada">
            <ng-template matStepLabel>Sede de atención</ng-template>



            <div class="container-fluid g-0 g-md-4">

              <div class="row">

                <div class="col-12">
                  <button type="button" class="btn btn-secondary btn-sm" matStepperPrevious>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-arrow-left mb-1" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                    </svg> Ir Atrás
                  </button>
                </div>

                <div class="col-12">
                  <div class="py-5">
                    <div class=" d-flex justify-content-center">
                      <div class="icon-head">
                        <img class="img-fluid w-100" src="assets/img/citas/icon-sede.svg" alt="Icon decorartivo">
                      </div>
                    </div>
                    <div class="pt-2 d-flex justify-content-center">
                      <span
                        [ngClass]="{'big-t title-line-height': true, 'blue': !global.color_filter, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                        SELECCIONE SU SEDE
                      </span>
                    </div>
                  </div>
                </div>

                <div *ngIf="alertSede" class="alert alert-info" role="alert">
                  Debe seleccionar un servicio en el paso anterior.
                </div>

                <div class="col-12" *ngIf="spinner2">
                  <div class="d-flex align-items-center justify-content-center my-4">
                    <div class="spinner-grow me-3" style="width: 1.5rem; height: 1.5rem;" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <strong>Cargando ubicaciones...</strong>
                  </div>
                </div>

                <div class="col-12" *ngIf="!alertSede && !spinner2 && sucursales.length === 0">
                  <div class="alert alert-warning" role="alert">
                    No se encontró ninguna sede.
                  </div>
                </div>

                <div class="col-12 col-md-4 col-xl-3 pb-2" *ngFor="let s of sucursales">
                  <a (click)="onSucursalCardClicked(s.key, stepper); scrollToTop200('#sede-anchor')">
                    <div class="box-hover d-flex justify-content-between p-3">
                      <div>
                        <span class="text-normal bold-f">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-geo-alt-fill mb-1" viewBox="0 0 16 16">
                            <path
                              d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
                          </svg> {{s.label}}
                        </span>
                      </div>
                      <div>
                        <span class="">
                          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
                            class="bi bi-arrow-right" viewBox="0 0 16 16">
                            <path fill-rule="evenodd"
                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </a>
                </div>



              </div>

              <!--    <div class="row g-0 g-md-4 MARIODIV">

                <div class="col-12">
                  <div class="row p-3">

                    <h3
                      [ngClass]="{'big-t title-line-height mt-3 mb-3': true, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                      SELECCIONE SU SEDE:</h3>

                    <div class="col-12" *ngIf="spinner2">
                      <div class="d-flex align-items-center justify-content-center my-4">
                        <div class="spinner-grow me-3" style="width: 1.5rem; height: 1.5rem;" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <strong>Cargando ubicaciones...</strong>
                      </div>
                    </div>

                    <div class="col-12" *ngIf="!spinner2 && !sucursales.length">
                      <div class="alert alert-warning" role="alert">
                        No hay ubicaciones disponibles para este servicio en el proximo mes.
                      </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4 mb-4" *ngFor="let s of sucursales">
                      <div class="card h-100 shadow-sm cursor-pointer"
                        [ngClass]="{'border-3 border-primary': sucursalSeleccionadaKey === s.key}"
                        (click)="onSucursalCardClicked(s.key, stepper)" role="button">
                        <div class="card-body">
                          <h5 class="card-title">{{s.label}}</h5>
                          <p class="card-text mb-2">
                            <strong>Agendas disponibles:</strong> {{s.value ? (s.value | keyvalue).length : 0}}
                          </p>
                          <p class="card-text text-muted">
                            Seleccione esta sede para ver las fechas disponibles.
                          </p>
                        </div>
                        <div class="card-footer bg-transparent border-0 text-end">
                          <span class="badge rounded-pill"
                            [ngClass]="{'bg-primary': sucursalSeleccionadaKey === s.key, 'bg-secondary': sucursalSeleccionadaKey !== s.key}">
                            {{sucursalSeleccionadaKey === s.key ? 'Seleccionada' : 'Seleccionar'}}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="col-12" *ngIf="errorAgenda">
                      <div class="alert alert-danger" role="alert">
                        {{errorAgenda}}
                      </div>
                    </div>

                  </div>
                </div>

              </div>
 -->


            </div>



            <div class="text-center">
              <p class="text-muted text-small mt-5">This site is protected by reCAPTCHA Enterprise and the Google
                <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                <a href="https://policies.google.com/terms">Terms of Service</a> apply.
              </p>
            </div>
          </mat-step>

          <mat-step [completed]="!!citaFechaHoraSeleccionada">
            <ng-template matStepLabel>Fecha y hora</ng-template>

            <div class="container-fluid g-0 g-md-4">

              <div class="row">
                <div class="col-12">
                  <button type="button" class="btn btn-secondary btn-sm" matStepperPrevious>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-arrow-left mb-1" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                    </svg> Ir Atrás
                  </button>
                </div>
              </div>

              <div class="row g-0 g-md-4">

                <div class="col-12">
                  <div class="pt-5">
                    <div class=" d-flex justify-content-center">
                      <div class="icon-head">
                        <img class="img-fluid w-100" src="assets/img/citas/icon-fecha.svg" alt="Icon decorartivo">
                      </div>
                    </div>
                    <div class="pt-2 d-flex justify-content-center">
                      <span
                        [ngClass]="{'big-t title-line-height': true, 'blue': !global.color_filter, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                        SELECCIONE FECHA Y HORA
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-lg-4 border-end">
                  <div class="d-flex justify-content-center pb-3">
                    <span [ngClass]="{'text-normal bold-f': true, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                      Seleccione el día de su cita
                    </span>
                  </div>


                  <div *ngIf="horario" class="d-flex align-items-center mb-3">
                    <div class="spinner-grow me-3" style="width: 1.5rem; height: 1.5rem;" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <strong>Cargando disponibilidad...</strong>
                  </div>

                  <div *ngIf="!horario && !minDateStruct" class="alert alert-info" role="alert">
                    Seleccione una sede para ver las fechas disponibles.
                  </div>

                  <div class="calendar-wrapper d-flex justify-content-center" *ngIf="!horario && minDateStruct">
                    <ngb-datepicker name="fechaPicker" [minDate]="minDateStruct" [maxDate]="maxDateStruct"
                      [markDisabled]="isDateDisabled" [displayMonths]="1" [outsideDays]="'hidden'"
                      [startDate]="selectedDateStruct || minDateStruct" [(ngModel)]="selectedDateStruct"
                      (ngModelChange)="onDatepickerChange($event)">
                    </ngb-datepicker>
                  </div>
                </div>

                <div class="col-12  col-lg-8">
                  <div class="d-flex justify-content-center pb-3 pt-4 pt-md-0">
                    <span [ngClass]="{'text-normal bold-f': true, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                      Seleccione una hora
                    </span>
                  </div>

                  <div *ngIf="horario" class="d-flex align-items-center mb-3">
                    <div class="spinner-grow me-3" style="width: 1.5rem; height: 1.5rem;" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <strong>Cargando horarios...</strong>
                  </div>

                  <div *ngIf="!horario && !fechaSeleccionada" class="alert alert-info" role="alert">
                    Seleccione una fecha del calendario para ver los horarios disponibles.
                  </div>

                  <div *ngIf="!horario && fechaSeleccionada && horariosDisponibles.length === 0"
                    class="alert alert-warning" role="alert">
                    No hay horarios disponibles para la fecha seleccionada.
                  </div>

                  <div class="row g-3" *ngIf="!horario && horariosDisponibles.length > 0">
                    <div class="col-6 col-md-4" *ngFor="let hora of horariosDisponibles">
                      <div class="card hora-card text-center"
                        [ngClass]="{'hora-card-selected': horaSeleccionada === hora}"
                        (click)="onHoraSeleccionada(hora, stepper); scrollToTop200('#sede-anchor')">
                        <div class="card-body">
                          <span class="fw-bold">{{hora}}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="errorAgenda && !horario" class="alert alert-warning mt-3" role="alert">
                    {{errorAgenda}}
                  </div>
                </div>

              </div>
            </div>
            <div class="text-center">
              <p class="text-muted text-small mt-5">This site is protected by reCAPTCHA Enterprise and the Google
                <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                <a href="https://policies.google.com/terms">Terms of Service</a> apply.
              </p>
            </div>
          </mat-step>

          <mat-step>
            <ng-template matStepLabel>Paciente</ng-template>



            <div class="container-fluid g-0 g-md-4">

              <div class="row">
                <div class="col-12">
                  <button type="button" class="btn btn-secondary" matStepperPrevious *ngIf="!formBloqueado">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-arrow-left mb-1" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                    </svg> Ir Atrás
                  </button>
                </div>
              </div>

              <div class="row">

                <div class="col-12 col-md-8 col-xl-6 mx-auto p-3" *ngIf="!formBloqueado">

                  <div class="pt-5 pb-3">
                    <div class=" d-flex justify-content-center">
                      <div class="icon-head">
                        <img class="img-fluid w-100" src="assets/img/citas/icon-pac.svg" alt="Icon decorartivo">
                      </div>
                    </div>
                    <div class="pt-2 d-flex justify-content-center">
                      <span
                        [ngClass]="{'big-t title-line-height': true, 'blue': !global.color_filter, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                        INFORMACIÓN DEL PACIENTE
                      </span>
                    </div>
                  </div>

                  <div *ngIf="!horario && horariosDisponibles.length > 0">
                    <label class="form-label">Ingrese su número de
                      identificación</label>
                    <div class="input-group mb-3">
                      <input type="text" class="form-control" [(ngModel)]="cedulaPaciente"
                        (change)="completarCitaForm()" type="text" (input)="validateChar($event)" name="fcedula"
                        autocomplete="off" #cedula placeholder="Numeros o letras">
                      <button class="btn btn-dark" type="button" id="button-addon2">Buscar</button>
                    </div>
                  </div>

                  <div class="col-12 col-md-8 col-lg-7" *ngIf="obteniendoDatosPaciente">
                    <div class="d-flex align-items-center">
                      <div class="spinner-grow me-3" style="width: 1.5rem; height: 1.5rem;" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <strong>Cargando datos del paciente...</strong>
                    </div>
                  </div>

                  <div *ngIf="showcompleteForm && !pacienteNoEncontrado" class="card text-bg-success mb-3">
                    <div class="card-header">
                      <span class="text-normal bold-f">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-person-circle mb-1" viewBox="0 0 16 16">
                          <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                          <path fill-rule="evenodd"
                            d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1" />
                        </svg> {{nombrePaciente}} {{primerApellidoPaciente}} {{segundoApellidoPaciente}}
                      </span>
                    </div>
                    <div class="card-body">
                      <div class="py-2">
                        <span class="text-normal regular-f"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                            height="16" fill="currentColor" class="bi bi-envelope mb-1 me-1" viewBox="0 0 16 16">
                            <path
                              d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" />
                          </svg> <strong>Correo:</strong> {{correoPaciente}}</span>
                      </div>
                      <div>
                        <span class="text-normal regular-f"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                            height="16" fill="currentColor" class="bi bi-telephone mb-1 me-1" viewBox="0 0 16 16">
                            <path
                              d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                          </svg> <strong>Teléfono:</strong> {{telefonoPaciente}}</span>
                      </div>
                      <div class="py-2">
                        <span class="text-normal regular-f"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                            height="16" fill="currentColor" class="bi bi-check-circle mb-1 me-1" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path
                              d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                          </svg> <strong>Género:</strong> {{getSexoLabel(sexoPaciente)}}</span>
                      </div>
                      <div class="py-2">
                        <span class="text-normal regular-f"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                            height="16" fill="currentColor" class="bi bi-calendar-week mb-1 me-1" viewBox="0 0 16 16">
                            <path
                              d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z" />
                            <path
                              d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                          </svg> <strong>Fecha de nacimiento:</strong> {{fechaNacimiento}}</span>
                      </div>
                      <div class="py-2">
                        <span class="text-normal regular-f"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                            height="16" fill="currentColor" class="bi bi-folder-check mb-1 me-1" viewBox="0 0 16 16">
                            <path
                              d="m.5 3 .04.87a2 2 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2m5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19q-.362.002-.683.12L1.5 2.98a1 1 0 0 1 1-.98z" />
                            <path
                              d="M15.854 10.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.707 0l-1.5-1.5a.5.5 0 0 1 .707-.708l1.146 1.147 2.646-2.647a.5.5 0 0 1 .708 0" />
                          </svg> <strong>Expediente:</strong> {{expediente}}</span>
                      </div>
                    </div>
                    <div class="card-footer">
                      <span class="text-small bold-f"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17"
                          fill="currentColor" class="bi bi-info-circle-fill mb-1 me-1" viewBox="0 0 16 16">
                          <path
                            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
                        </svg> ¿Información incorrecta o sin registro? Llámenos al +506 2285 5881.</span>
                    </div>
                  </div>

                  <div class="alert alert-secondary" role="alert" *ngIf="pacienteNoEncontrado">
                    No hemos encontrado su registo, llámenos al +506 2285 5881.
                  </div>

                  <div class="col-12 d-flex justify-content-center" *ngIf="!pacienteNoEncontrado">
                    <div class="">
                      <button class="btn btn-success btn-lg mt-4"
                        (click)="agendarCita(); scrollToTop200('#sede-anchor')"
                        [disabled]="spinner || !showcompleteForm || !nombrePaciente || !primerApellidoPaciente || !cedulaPaciente || !correoPaciente">
                        AGENDAR CITA
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-check-circle ms-2" viewBox="0 0 16 16">
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                          <path
                            d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                        </svg>
                      </button>
                    </div>

                    <div class="" *ngIf="spinner">
                      <div class="d-flex justify-content-center mt-3">
                        <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </div>

                    <div class="" *ngIf="!formBloqueado && errorCita">
                      <div class="alert alert-danger" role="alert">{{errorCita}}</div>
                    </div>
                  </div>

                  <!-- <div class="row g-3">

                    <div class="col-12 col-md-6">
                      <label class="form-label"><span class="badge rounded-pill bg-info text-dark">1</span> Cedula de
                        identidad</label>
                      <input class="form-control" aria-label="default input example" [(ngModel)]="cedulaPaciente"
                        (change)="completarCitaForm()" type="text" (input)="validateChar($event)" name="fcedula"
                        autocomplete="off" #cedula placeholder="Numeros o letras">
                    </div>

                    <div class="col-12" *ngIf="obteniendoDatosPaciente">
                      <div class="d-flex align-items-center">
                        <div class="spinner-grow me-3" style="width: 1.5rem; height: 1.5rem;" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <strong>Cargando datos del paciente...</strong>
                      </div>
                    </div>

                    <ng-container *ngIf="showcompleteForm">
                      <div class="col-12 col-md-6">
                        <label class="form-label mt-3"><span class="badge rounded-pill bg-info text-dark">2</span>
                          Nombre</label>
                        <input class="form-control" aria-label="default input example" [(ngModel)]="nombrePaciente"
                          type="text" name="fname" placeholder="" [readonly]="disablePatientForm">
                      </div>
                      <div class="col-12 col-md-6">
                        <label class="form-label mt-3"><span class="badge rounded-pill bg-info text-dark">3</span>
                          Primer apellido</label>
                        <input class="form-control" aria-label="default input example"
                          [(ngModel)]="primerApellidoPaciente" type="text" name="fprimerApellido" placeholder=""
                          [readonly]="disablePatientForm">
                      </div>
                      <div class="col-12 col-md-6">
                        <label class="form-label mt-3"><span class="badge rounded-pill bg-info text-dark">4</span>
                          Segundo apellido</label>
                        <input class="form-control" aria-label="default input example"
                          [(ngModel)]="segundoApellidoPaciente" type="text" name="fsegundoApellido" placeholder=""
                          [readonly]="disablePatientForm">
                      </div>
                      <div class="col-12 col-md-6">
                        <label class="form-label mt-3"><span class="badge rounded-pill bg-info text-dark">5</span>
                          Correo electronico</label>
                        <input class="form-control" aria-label="default input example" [(ngModel)]="correoPaciente"
                          type="text" name="fcorreo" placeholder="" [readonly]="disablePatientForm">
                      </div>
                      <div class="col-12 col-md-6">
                        <label class="form-label mt-3"><span class="badge rounded-pill bg-info text-dark">6</span>
                          Numero de telefono</label>
                        <input class="form-control" aria-label="default input example" [(ngModel)]="telefonoPaciente"
                          type="text" name="ftelefono" placeholder="" [readonly]="disablePatientForm">
                      </div>
                      <div class="col-12 col-md-6">
                        <label class="form-label mt-3"><span class="badge rounded-pill bg-info text-dark">7</span>
                          Genero</label>
                        <select class="form-select mb-3" [(ngModel)]="sexoPaciente" name="fsexo"
                          [disabled]="disablePatientForm">
                          <option value="1">Mujer</option>
                          <option value="2">Hombre</option>
                        </select>
                      </div>
                      <div class="col-12 col-md-6" *ngIf="userMail">
                        <label class="form-label mt-3"><span class="badge rounded-pill bg-info text-dark">8</span>
                          Numero de expediente</label>
                        <input class="form-control" aria-label="default input example" [(ngModel)]="expediente"
                          type="text" name="fexpediente" placeholder="" [readonly]="disablePatientForm">
                      </div>
                      <div class="col-12 col-md-6" *ngIf="userMail">
                        <label class="form-label mt-3"><span class="badge rounded-pill bg-info text-dark">9</span> Fecha
                          de nacimiento</label>
                        <input class="form-control" aria-label="default input example" [(ngModel)]="fechaNacimiento"
                          type="date" name="ffechaNacimiento" [disabled]="disablePatientForm" [max]="tomorrow">
                      </div>
                    </ng-container>

                    <div class="col-12 d-flex justify-content-end">
                      <button class="btn btn-success btn-lg mt-4" (click)="agendarCita()"
                        [disabled]="spinner || !showcompleteForm || !nombrePaciente || !primerApellidoPaciente || !cedulaPaciente || !correoPaciente">
                        AGENDAR CITA
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-check-circle ms-2" viewBox="0 0 16 16">
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                          <path
                            d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                        </svg>
                      </button>
                    </div>

                    <div class="col-12" *ngIf="spinner">
                      <div class="d-flex justify-content-center mt-3">
                        <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-12" *ngIf="!formBloqueado && errorCita">
                      <div class="alert alert-danger" role="alert">{{errorCita}}</div>
                    </div>

                  </div> -->
                </div>

                <div class="col-12 col-md-7 mx-auto p-3" *ngIf="formBloqueado">

                  <div class="card confirm-card mt-4" *ngIf="confirmacionCita && resumenCita">
                    <div class="card-body">
                      <div class="text-center mb-4">
                        <div class="pt-5">
                          <div class=" d-flex justify-content-center">
                            <div class="icon-head">
                              <img class="img-fluid w-100" src="assets/img/citas/icon-cita.svg" alt="Icon decorartivo">
                            </div>
                          </div>
                          <div class="pt-2 d-flex justify-content-center">
                            <span
                              [ngClass]="{'big-t title-line-height': true, 'blue': !global.color_filter, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                              CITA CONFIRMADA
                            </span>
                          </div>
                        </div>
                        <p class="text-big mb-3">Numero de cita: {{confirmacionCita}}</p>
                      </div>
                      <div class="row">
                        <div class="col-12 col-md-6">
                          <span class="big-text bold-f">Detalle de la cita:</span>
                          <ul class="list-unstyled mb-0">
                            <li><strong>Especialidad:</strong> {{resumenCita?.especialidad}}</li>
                            <li><strong>Servicio:</strong> {{resumenCita?.servicio}}</li>
                            <li><strong>Ubicacion:</strong> {{resumenCita?.sede}}</li>
                            <li><strong>Fecha:</strong> {{resumenCita?.fecha}}</li>
                            <li><strong>Hora:</strong> {{resumenCita?.hora}}</li>
                          </ul>
                        </div>
                        <div class="col-12 col-md-6 mt-3 mt-md-0">
                          <span class="big-text bold-f">Datos del paciente:</span>
                          <ul class="list-unstyled mb-0">
                            <li><strong>Nombre:</strong> {{resumenCita?.paciente?.nombre}}
                              {{resumenCita?.paciente?.primerApellido}} {{resumenCita?.paciente?.segundoApellido}}</li>
                            <li><strong>Cedula:</strong> {{resumenCita?.paciente?.cedula}}</li>
                            <li><strong>Correo:</strong> {{resumenCita?.paciente?.correo}}</li>
                            <li><strong>Telefono:</strong> {{resumenCita?.paciente?.telefono}}</li>
                          </ul>
                        </div>
                      </div>
                      <div class="text-center mt-4">
                        <button (click)="volver()" type="button"
                          [ngClass]="{'btn m-2': true,'cursor': global.cursor_btn, 'btn-warning': !global.color_filter, 'btn-dark': global.color_filter}">
                          Volver a página de inicio
                        </button>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="!confirmacionCita && errorCita"
                    class="w-100 bg-white corners-rounded shadow-box p-5 text-center">
                    <div>
                      <span [ngClass]="{'big-t bold-f title-line-height': true, 'dislex': global.dislex}"><svg
                          xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
                          class="bi bi-exclamation-octagon-fill mb-1" viewBox="0 0 16 16">
                          <path
                            d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
                        </svg> No
                        se pudo agendar la cita</span>
                    </div>
                    <p class="py-4">{{errorCita}}</p>
                    <div class="pt-3 d-flex justify-content-center gap-2">
                      <button type="button" class="btn btn-dark"
                        (click)="back(); formBloqueado = false; confirmacionCita = null; resumenCita = null;"
                        matStepperPrevious>
                        Elegir otro horario
                      </button>
                      <button type="button" class="btn btn-warning" (click)="volver()">
                        Volver a página de inicio
                      </button>
                    </div>
                  </div>
                </div>

              </div>


            </div>
            <div class="text-center">
              <p class="text-muted text-small mt-5">This site is protected by reCAPTCHA Enterprise and the Google
                <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                <a href="https://policies.google.com/terms">Terms of Service</a> apply.
              </p>
            </div>
          </mat-step>

        </mat-stepper>
      </div>
    </div>
  </div>
</section>

<section class="none-phone">
  <div
    [ngClass]="{'container corners-rounded mb-5 mt-5': true,'bg-turquesa': !global.color_filter, 'bg-gray': global.color_filter}">
    <div class="row">
      <div class="col-12 col-md-4 col-lg-2">
        <img class="mt-4 mb-4 icon-contact-box" src="assets/img/icons/icon-contac-box.png">
      </div>

      <div class="col-12 col-md-8 col-lg-4">
        <h3
          [ngClass]="{'big-t mt-4 mb-2': true, 'white': !global.color_filter, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
          ESTAMOS SIEMPRE DISPUESTOS A ATENDERLES</h3>
        <div class="d-flex justify-content-start mb-3">
          <a class="text-decoration-none me-4" style="cursor: pointer;"
            href="https://www.instagram.com/clinicas_asembis/" target="_blank">
            <h6
              [ngClass]="{'white': !global.color_filter, 'black': global.color_filter, 'roboto': !global.dislex, 'dislex': global.dislex, 'text-small': !global.sizetext, 'sizetext': global.sizetext}">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                class="bi bi-instagram me-1 mb-1" viewBox="0 0 16 16">
                <path
                  d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
              </svg>
              clinicas_asembis
            </h6>
          </a>

          <a class="text-decoration-none" style="cursor: pointer;" href="https://www.facebook.com/Asembis/"
            target="_blank">
            <h6
              [ngClass]="{'white': !global.color_filter, 'black': global.color_filter, 'roboto': !global.dislex, 'dislex': global.dislex, 'text-small': !global.sizetext, 'sizetext': global.sizetext}">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                class="bi bi-facebook me-1 mb-1" viewBox="0 0 16 16">
                <path
                  d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
              </svg>
              Clinicas Asembis
            </h6>
          </a>
        </div>
      </div>

      <div class="col-12 col-md-12 col-lg-6">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 center-ipad mb-md-4 mb-lg-0">
              <h5
                [ngClass]="{'text-big mt-4': true, 'white': !global.color_filter, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                  class="bi bi-telephone-fill me-2" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                </svg>
                TELEFONOS
              </h5>
              <p
                [ngClass]="{'mb-0 ms-2': true, 'white': !global.color_filter, 'black': global.color_filter, 'roboto': !global.dislex, 'dislex': global.dislex, 'text-normal': !global.sizetext, 'sizetext': global.sizetext}">
                Llamadas: +506 2285 5881</p>
              <p
                [ngClass]="{'ms-2': true, 'white': !global.color_filter, 'black': global.color_filter, 'roboto': !global.dislex, 'dislex': global.dislex, 'text-normal': !global.sizetext, 'sizetext': global.sizetext}">
                Whatsapp: +506 8814 5881</p>
            </div>
            <div class="col-12 col-md-6 center-ipad mb-md-4 mb-lg-0">
              <h5
                [ngClass]="{'text-big mt-4': true, 'white': !global.color_filter, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                  class="bi bi-envelope-fill me-2" viewBox="0 0 16 16">
                  <path
                    d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z" />
                </svg>
                CORREO
              </h5>
              <p
                [ngClass]="{'mb-0 ms-2': true, 'white': !global.color_filter, 'black': global.color_filter, 'roboto': !global.dislex, 'dislex': global.dislex, 'text-normal': !global.sizetext, 'sizetext': global.sizetext}">
                contacto@asembis.org</p>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="only-phone">
  <div class="container mb-5 mt-5">
    <div class="row d-flex justify-content-center">

      <div
        [ngClass]="{'col-9 corners-rounded': true,'bg-turquesa': !global.color_filter, 'bg-gray': global.color_filter}">
        <img class="mt-5 mb-4 icon-contact-box" src="assets/img/icons/icon-contac-box.png">

        <h3
          [ngClass]="{'big-t mt-4 text-center mb-2': true, 'white': !global.color_filter, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
          ESTAMOS SIEMPRE DISPUESTOS A ATENDERLES</h3>

        <div class="d-flex justify-content-center mb-5 mt-5">
          <a [ngClass]="{'text-decoration-none me-4': true, 'white': !global.color_filter, 'black': global.color_filter}"
            style="cursor: pointer;" href="https://www.instagram.com/clinicas_asembis/" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"
              class="bi bi-instagram me-3" viewBox="0 0 16 16">
              <path
                d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
            </svg>
          </a>

          <a [ngClass]="{'text-decoration-none': true, 'white': !global.color_filter, 'black': global.color_filter}"
            style="cursor: pointer;" href="https://www.facebook.com/Asembis/" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"
              class="bi bi-facebook ms-3" viewBox="0 0 16 16">
              <path
                d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
            </svg>
          </a>
        </div>

        <h5
          [ngClass]="{'text-big text-center mt-4': true, 'white': !global.color_filter, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
            class="bi bi-telephone-fill me-2" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
          </svg>
          TELEFONOS
        </h5>
        <p
          [ngClass]="{'text-center mb-0': true, 'white': !global.color_filter, 'black': global.color_filter, 'roboto': !global.dislex, 'dislex': global.dislex, 'text-normal': !global.sizetext, 'sizetext': global.sizetext}">
          Llamadas: +506 2285 5881</p>
        <p
          [ngClass]="{'text-center mb-0': true, 'white': !global.color_filter, 'black': global.color_filter, 'roboto': !global.dislex, 'dislex': global.dislex, 'text-normal': !global.sizetext, 'sizetext': global.sizetext}">
          Whatsapp: +506 8814 5881</p>

        <h5
          [ngClass]="{'text-big text-center mt-4': true, 'white': !global.color_filter, 'black': global.color_filter, 'bold-f': !global.dislex, 'dislex': global.dislex}">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
            class="bi bi-envelope-fill me-2" viewBox="0 0 16 16">
            <path
              d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z" />
          </svg>
          CORREOS
        </h5>
        <p
          [ngClass]="{'text-center mb-5': true, 'white': !global.color_filter, 'black': global.color_filter, 'light-f': !global.dislex, 'dislex': global.dislex, 'text-normal': !global.sizetext, 'sizetext': global.sizetext}">
          contacto@asembis.org</p>


      </div>

    </div>
  </div>
</section>

<app-foot></app-foot>
